/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.ImageMultiselectNoQuestion.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.ImageMultiselectNoQuestion.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.answers = [];
  this.highlighted = [];
  this.correctAnswers = 0;
};

EDC.Games.ImageMultiselectNoQuestion.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.ImageMultiselectNoQuestion.Scenes.Main.prototype.constructor = EDC.Games.ImageMultiselectNoQuestion.Scenes.Main;

const IMNQ = EDC.Games.ImageMultiselectNoQuestion.Scenes.Main.prototype;

IMNQ.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

IMNQ.loadIteration = function () {
  this.createAnswers();
};

IMNQ.createAnswers = function () {
  const { answers } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  for (let i = 0; i < answers.length; i++) {
    const container = this.add.container(0, 250 + 380 * Math.floor(i / 3));
    container.init_Y = container.y;
    const item = this.add.sprite(0, 0, `asset-${answers[i]}`);
    item.displayWidth = 250;
    item.displayHeight = 250;
    container.add(item);
    container.setSize(250, 250);
    container.assetKey = answers[i];
    this.shakeAnimation(container);
    container.setInteractive();
    const markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.checkClick.bind(this, container), this);
    this.answers.push(container);
  }
  this.adjustPosition(this.answers);
};

IMNQ.checkClick = function (container) {
  if (this.highlighted.length === 0) {
    this.tweens.add({
      targets: container,
      scaleX: 1.2,
      scaleY: 1.2,
      duration: 100,
      ease: 'Linear',
    });
    container.floatAnim = this.tweens.add({
      targets: container,
      y: container.init_Y + 10,
      duration: 400,
      repeat: -1,
      ease: 'Linear',
      yoyo: true,
    });
    container.selected = true;
    this.highlighted.push(container);
  } else if (this.highlighted.length === 1) {
    if (container.selected) {
      container.setScale(1);
      container.floatAnim.stop();
      container.y = container.init_Y;
      container.selected = false;
      this.highlighted = [];
    } else {
      this.highlighted[0].setScale(1);
      this.highlighted[0].floatAnim.stop();
      this.highlighted[0].y = this.highlighted[0].init_Y;
      this.highlighted.push(container);
      this.checkAnswer();
    }
  }
};

IMNQ.checkAnswer = function () {
  const { solution } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const key1 = this.highlighted[0].assetKey;
  const key2 = this.highlighted[1].assetKey;
  let isCorrect = false;
  for (let i = 0; i < solution.length; i++) {
    const answer = solution[i];
    if (answer.indexOf(key1) !== -1 && answer.indexOf(key2) !== -1) {
      isCorrect = true;
      this.correctAnswers = this.correctAnswers + 1;
    }
  }
  if (isCorrect) {
    this.playCorrect();
    this.highlighted.map((x) => {
      x.disableInteractive();
      x.shakeAnim.stop();
      x.angle = 0;
      x.getData('markAnim').showMark(true, () => {});
      return true;
    });
    if (this.correctAnswers === solution.length) {
      this.time.delayedCall(2000, this.shrinkAnimation, [], this);
    }
  } else {
    this.playWrong();
    this.wrongAnimation();
  }
  this.highlighted.map((x) => {
    x.selected = false;
    return true;
  });
  this.highlighted = [];
};

IMNQ.shrinkAnimation = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.answers.map((x) => {
      this.tweens.add({
        targets: x,
        scaleX: '+=0.2',
        scaleY: '+=0.2',
        duration: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
      this.tweens.add({
        targets: x,
        scaleX: 0,
        scaleY: 0,
        duration: 500,
        delay: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
      return true;
    });
    this.time.delayedCall(1100, this.nextIteration, [], this);
  }
};

IMNQ.nextIteration = function () {
  this.answers.map((x) => {
    x.destroy();
    return true;
  });
  this.answers = [];
  this.correctAnswers = 0;
  this.loadIteration();
};

IMNQ.wrongAnimation = function () {
  this.tweens.add({
    targets: this.highlighted.map((container) => {
      container.getAt(0).setTint(0xff0000);
      return container;
    }),
    x: '-=15',
    duration: 50,
    ease: 'Linear',
    repeat: 8,
    yoyo: true,
    onComplete: (tween, targets) => {
      targets.map((x) => {
        x.getAt(0).clearTint();
        return true;
      });
    },
  });
};

IMNQ.shakeAnimation = function (item) {
  item.shakeAnim = this.tweens.add({
    targets: item,
    angle: item.angle - 6,
    duration: 90,
    ease: 'Sine.easeInOut',
    repeat: 4,
    delay: 6500,
    yoyo: true,
    onComplete: this.shakeAnimation.bind(this, item),
  });
};

IMNQ.adjustPosition = function (array) {
  const width = array.length * array[0].displayWidth;
  const startingX = (this.game.config.width - width) / 2 + 500;
  for (let i = 0; i < array.length; i++) {
    const targetX = startingX + (array[0].displayWidth + 120) * (i % 3);
    array[i].init_X = targetX;
    array[i].x = targetX;
  }
};

IMNQ.createTemplateUI = function () {
  let title; let instructions;
  const { titleImg } = this.gameConfig;
  const { instructionsImg } = this.gameConfig;
  if (titleImg) {
    title = this.add.sprite(10, 10, 'title').setOrigin(0);
  } else {
    title = this.make.text({
      x: 30,
      y: 30,
      text: this.gameConfig.titleTxt,
      origin: { x: 0, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.titleSize}`,
        wordWrap: { width: '450' },
        lineSpacing: 5,
        align: 'center',
      },
    });
  }
  if (instructionsImg) {
    instructions = this.add.sprite(this.game.config.width / 2, 1000, 'instructions').setOrigin(0.5);
  } else {
    instructions = this.make.text({
      x: this.game.config.width / 2,
      y: 1000,
      text: this.gameConfig.instructionsTxt,
      origin: { x: 0.5, y: 0.5 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.instructionsSize}`,
        wordWrap: { width: `${this.gameConfig.instructionsMaxWidth}` },
        lineSpacing: 10,
      },
    });
  }
};

export default EDC.Games.ImageMultiselectNoQuestion.Scenes.Main;
